import { render, staticRenderFns } from "./PheProjectDetails.vue?vue&type=template&id=edcd54f4&"
import script from "./PheProjectDetails.vue?vue&type=script&lang=js&"
export * from "./PheProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./PheProjectDetails.vue?vue&type=style&index=0&id=edcd54f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports